import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import EditUpdateComp from "./Component/EditUpdateComp"

const EditUpdate =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditUpdateComp />
        </div>
        <Footer />
        </>
    )
}

export default EditUpdate